import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  oversightDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-agendaItem-document.controller';
import directive from './attach-agendaItem-document.directive';


export default angular.module('app.components.advisory.oversight.attachAgendaItemDocument', [
  alerts,
  oversightDataService,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('attachAgendaItemDocument', directive)
  .controller('AttachAgendaItemDocumentController', controller)
  .name;

console.log('app.components.advisory.oversight.attachAgendaItemDocument created');
